import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import NextToolsRoutes from '~/router/NextToolsRoutes';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const NextTools = forwardRef((props, ref) => (
  <div
    ref={ref}
    className={classnames('ndx-Sidebar-container', props.className)}
    style={props.style}>
    <div className="ndx-Sidebar">
      <NextToolsRoutes {...props} />
      {props.children}
    </div>
  </div>
));
NextTools.displayName = 'NextTools';

const propTypes = {
  blankDesign: PropTypes.bool.isRequired,
  designDirty: PropTypes.bool.isRequired,
  setAfterSavePath: PropTypes.func.isRequired,
  setOrderOptionsPath: PropTypes.func.isRequired,
  animationIn: PropTypes.object,
  animationOut: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
  hooks: PropTypes.object,
  router: PropTypes.shape({
    back: PropTypes.func,
    navigate: PropTypes.func
  }),
  setCombineDesigns: PropTypes.func,
  style: PropTypes.object
};

NextTools.propTypes = propTypes;

export default NextTools;
